module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs/export_ical.png?102b447611cdca2b816637d07a1b4ba0";